import { noop } from 'lodash'
import * as React from 'react'
import * as events from '../../../events'

import {
  Text,
  Colors,
  InlineChildren,
  StackChildren,
} from '@doordash/design-language'
import Logo from '@doordash/component-logo'
import { Modal } from '@doordash/component-modal'
import { connect } from 'react-redux'
import { IconSizes } from '../../atoms/icons'
import { CheckrIcon } from '../../atoms/icons/CheckrIcon'
import { LongArrowIcon } from '../../atoms/icons/LongArrowIcon'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { loadUrl } from '../../../webview'
import { OsTypes } from '../../../webview/types'
import t from './strings'

type Props = {
  checkrCompletionUrl?: string
  trackRedirectToCheckr?: () => Promise<any>
  trackRenderRedirectToCheckr?: () => Promise<any>
}

export class DDToCheckrModal extends React.Component<Props> {
  public static defaultProps = {
    checkrCompletionUrl: 'checkr.com',
    trackRedirectToCheckr: noop,
    trackRenderRedirectToCheckr: noop,
  }

  public onRedirectToCheckr = async () => {
    const os = detectWebviewOs()
    const isWebview = os !== OsTypes.NONE
    const { trackRedirectToCheckr } = this.props
    await trackRedirectToCheckr()

    if (isWebview) {
      loadUrl(this.props.checkrCompletionUrl)
    }
  }

  public componentDidMount() {
    this.props.trackRenderRedirectToCheckr()
  }

  public render() {
    return (
      <Modal
        title={t.title()}
        hasCloseButton={false}
        actionsFillContainer={true}
        isFooterFixedPosition
        isFullScreenOnMobile
        primaryAction={{
          text: t.button(),
          onClick: this.onRedirectToCheckr,
          buttonProps: {
            tag: 'a',
            href: this.props.checkrCompletionUrl,
          },
        }}
      >
        <StackChildren>
          <InlineChildren
            size={InlineChildren.Sizes.Large}
            justifyContent={InlineChildren.Justification.Center}
            alignItems={InlineChildren.Alignment.Center}
          >
            <Logo size={Logo.Sizes.Huge} showLogoText={false} />
            <LongArrowIcon size={IconSizes.LARGE} color={Colors.SystemBlack} />
            <CheckrIcon size={IconSizes.LARGE} color={Colors.SystemBlack} />
          </InlineChildren>
          <Text>{t.textOne()}</Text>
          <Text>{t.textTwo()}</Text>
        </StackChildren>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    checkrCompletionUrl: state.application.backgroundCheckCompletionUrl,
  }
}

const mapDispatchToProps = {
  trackRenderRedirectToCheckr: events.trackRenderRedirectToCheckr,
  trackRedirectToCheckr: events.trackRedirectToCheckr,
}

export default connect(mapStateToProps, mapDispatchToProps)(DDToCheckrModal)
